function simpleHasher(dayNum) {
    return Math.pow(dayNum * 16, 2) + 3 * dayNum;
}


export default simpleHasher;